import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IncidentEventTypeDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-incident-event-type',
  templateUrl: './incident-event-type.component.html',
  styleUrls: ['./incident-event-type.component.scss']
})
export class IncidentEventTypeComponent implements OnChanges {
  incidentEventTypeForm: FormGroup;
  incidentEventTypeFormArray: FormGroup;
  control = new FormControl();
  @Input() incidentEventTypes: IncidentEventTypeDto[];
  @Input() routeAnimationsElements: any;
  @Output() incidentEventType = new EventEmitter<IncidentEventTypeDto[]>()
  @Output() deleteIncidentEventTypeEvent = new EventEmitter<any>()

    selectedIncidentEventType: any;
    filteredDelete: Array<any> = [];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createincidentEventTypeForm();
    }

    createincidentEventTypeForm() {
      this.incidentEventTypeForm = this.fb.group({
        EventName: ['', Validators.required],
        EventDescription: [''],
        id: null
        });
        this.incidentEventTypeFormArray = this.fb.group({ IncidentEventTypes: this.fb.array([])
          });
        this.setIncidentEventType();
    }

  // method to display IncidentEventType
  setIncidentEventType() {
    const control  = this.incidentEventTypeFormArray.controls.IncidentEventTypes as FormArray;
    this.incidentEventTypes.forEach( e => {
      control.push(
        this.fb.group({
          EventName: e.EventName,
          EventDescription: e.EventDescription,
          id: e.id
        })
      );
    });
  }


  // method to add IncidentEventType
  addIncidentEventType(value: IncidentEventTypeDto) {
    const control  = this.incidentEventTypeFormArray.controls.IncidentEventTypes as FormArray;
    control.insert(0,
          this.fb.group({
            EventName: value.EventName,
            EventDescription: value.EventDescription,
            id: null
          })
       );
  }

  selectIncidentEventType(value) {}

  // method to delete IncidentEventType from arrary list
  deleteIncidentEventType(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.incidentEventTypeFormArray.controls.IncidentEventTypes as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.incidentEventTypes.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.incidentEventTypes[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: IncidentEventTypeDto) {
    if(this.incidentEventTypeForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.incidentEventTypeFormArray.get('IncidentEventTypes')['controls'][this.selectedIndex].patchValue({...formValue});
    } else {
      this.addIncidentEventType(formValue);
    }
    this.selectedIndex = null;
    this.incidentEventTypeForm.reset()
  }

  onEdit(index, value: IncidentEventTypeDto) {
    this.selectedIndex = index;
    this.incidentEventTypeForm.patchValue({...value});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.incidentEventTypeForm.reset();
  }

  onSubmit(formValue: IncidentEventTypeDto[]) {
  this.incidentEventType.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteIncidentEventTypeEvent.emit(this.filteredDelete);
  }
  }
  

}




